import { Actions } from 'vuex-smart-module';

import { UserService } from '../services';
import { User } from '../types';
import UserGetters from './getters';
import UserMutations from './mutations';
import UserState from './state';

const userService = new UserService();

export default class UserActions extends Actions<
  UserState,
  UserGetters,
  UserMutations,
  // eslint-disable-next-line no-use-before-define
  UserActions
> {
  async get_user_info() {
    try {
      const { data } = await userService.get_own_profile();

      if (data) this.mutations.SET_USER_INFO(data);

      if (data && data.main_menu) {
        this.mutations.SET_MAIN_MENU(data.main_menu);
      }

      if (data && data.favorites_menu) {
        this.mutations.SET_FAVORITES_MENU(data.favorites_menu);
      }

      if (data && data.help_menu) {
        this.mutations.SET_HELP_MENU(data.help_menu);
      }

      if (data && data.last_news) {
        this.mutations.SET_NEWS_DIALOG_MODAL(true);
      }
    } catch (error) {
      console.log('error: ', error);
    }
  }

  async update_user_info() {
    try {
      const { editable_me } = this.state;
      const success = await userService.update_user_info(editable_me);

      if (success) {
        this.mutations.SET_USER_INFO(editable_me);
        this.mutations.RESET_EDITABLE_ME();
        return success;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async update_user_avatar() {
    try {
      const avatar = this.state.editable_me.image;

      if (avatar instanceof File) {
        const response = await userService.update_user_avatar(avatar);

        if (response.success) {
          this.mutations.UPD_ME_FIELD({ key: 'avatar', value: response.data.path });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async update_password(data: User.PasswordApiUpdate) {
    await userService.update_password(data);
  }

  async send_email(email: string) {
    await userService.send_email(email);
  }

  async send_email_validation_code(data: User.EmailValidationCodeApi) {
    await userService.send_email_validation_code(data);
    this.mutations.SET_USER_EMAIL(data.email);
  }

  reset_user() {
    this.mutations.RESET_CURRENT_USER();
  }

  async add_favorite(item: User.MainMenuItem) {
    if (item.is_favorite) {
      return;
    }

    try {
      await userService.add_to_favorites(item.id);

      this.mutations.ADD_FAVORITES(item);
    } catch (error) {
      console.error(error);
    }
  }

  async delete_favorite(item: User.MainMenuItem) {
    if (!item.is_favorite) {
      return;
    }

    try {
      await userService.remove_from_favorites(item.id);

      this.mutations.DELETE_FAVORITE(item);
    } catch (error) {
      console.error(error);
    }
  }
}
